<template>
    <div class="result-dialog">
        <section class="board">
            <button v-for="(curNo) of 40" :key="curNo" 
                class="number-btn"
                :class="getBtnClassName(curNo)"
            >
                <span>{{curNo}}</span>
            </button>
        </section>
    </div>
</template>

<script lang="ts" >
export default defineComponent({name: 'KenoContent'});
</script>

<script lang="ts" setup>
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
        default: () => ({}),
    },
});


// 数据结构示例： 
// roll_number : (10) ['5', '11', '37', '17', '35', '10', '3', '22', '4', '36']
// selected : (3) [20, 21, 22]
function getBtnClassName(iNumber:number){ 
    let {roll_number, selected} = props.history;
    roll_number = roll_number || []
    selected = selected || []
    roll_number = roll_number.map(cur => Number(cur));
    const hasChosen = selected.includes(iNumber);
    const keyName = hasChosen ? 'selected': 'default';
    const obj = {
        [keyName]: true,
    };
    if (roll_number.includes(iNumber)){
        obj.default = false;
        if (hasChosen){
            obj.win = true;
        }else{
            obj.result = true;
        }
    }
    return obj;
}


</script>

<style scoped lang="scss"
    src="@/pages/casino/kenoGame/style/keno.scss"
></style>

<style scoped lang="scss">
.result-dialog{
    padding: 5px 0;
    .board{
        background-image: none !important;
        padding: 0;
        width: 100%;
        max-width: 100%;
        pointer-events: none; 
        .number-btn{
            // width: 100%;
            // max-width: 56px;
            // max-height: 56px;
            aspect-ratio: 1/1;
            width: auto;
            height: auto;
        }
    }
}

</style>




